var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"confetti",staticClass:"result-confetti",attrs:{"id":"result-confetti"}},_vm._l((_vm.numberOfConfetti),function(bit){return _c('div',{key:bit,staticClass:"confetti__bit",style:([_vm.confettiBitStyle()])})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }